import { FormEvent, useState } from "react";
import { InventoryItemAdjustmentRequest } from "../types";
export function StockAdjustmentForm({
  submitting,
  onSubmit,
}: {
  submitting?: boolean;
  onSubmit: (payload: InventoryItemAdjustmentRequest) => Promise<void> | void;
}) {
  const [adjustmentType, setAdjustmentType] = useState<"IN" | "OUT">("IN");
  const [quantityInIssueUnits, setQuantityInIssueUnits] = useState(0);
  async function submit(event: FormEvent) {
    event.preventDefault();
    await onSubmit({ adjustmentType, quantityInIssueUnits });
    setQuantityInIssueUnits(0);
  }
  return (
    <form onSubmit={submit} className="rounded-2xl border bg-white p-5 shadow-sm">
      <h2 className="text-lg font-bold text-slate-900">Stock Adjustment</h2>
      <p className="mb-4 text-sm text-slate-500">Use this for controlled manual correction before full issue workflows.</p>
      <div className="grid gap-4 md:grid-cols-2">
        <label className="space-y-1.5 text-sm font-medium text-slate-700">
          <span>Adjustment Type</span>
          <select className="input" value={adjustmentType} onChange={(e) => setAdjustmentType(e.target.value as "IN" | "OUT")}>
            <option value="IN">Stock In</option>
            <option value="OUT">Stock Out</option>
          </select>
        </label>
        <label className="space-y-1.5 text-sm font-medium text-slate-700">
          <span>Quantity in Issue Units</span>
          <input className="input" type="number" min="0.0001" step="0.0001" value={quantityInIssueUnits} onChange={(e) => setQuantityInIssueUnits(Number(e.target.value))} required />
        </label>
      </div>
      <div className="mt-4 flex justify-end">
        <button disabled={submitting} className="rounded-xl bg-slate-900 px-5 py-2.5 text-sm font-semibold text-white hover:bg-slate-800 disabled:opacity-60">
          {submitting ? "Applying..." : "Apply Adjustment"}
        </button>
      </div>
    </form>
  );
}
